import React from "react";
import "./Achivments.css";
import CardContains from "../CardContains";

export default function Achivments() {
  return (
    <div className="achivments-card">
      <CardContains
        InstitutionName={"World and Indian History🧠"}
        DegreeDetails={
          "World and Indian history are captivating tapestries that unfold the rich complexities of human civilization, revealing stories of triumphs, tragedies, and the enduring spirit of humanity."
        }
      />
      <CardContains
        InstitutionName={"Books and Audio Books📚 "}
        DegreeDetails={
          "I find immense joy in delving into the pages of books, where fascinating worlds come alive, and knowledge becomes an endless adventure of the mind. Reading is my gateway to exploration and enlightenmen. "
        }
      />
      <CardContains
        InstitutionName={"FootBall ⚽"}
        DegreeDetails={
          "Not a game . It's an emotion . Love both watching and playing"
        }
      />
    </div>
  );
}
